import { render } from "./vSprite.vue?vue&type=template&id=e49e2084&scoped=true"
import script from "./vSprite.vue?vue&type=script&lang=js"
export * from "./vSprite.vue?vue&type=script&lang=js"

import "./vSprite.vue?vue&type=style&index=0&id=e49e2084&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e49e2084"]])

export default __exports__